export default "__VITE_ASSET__DKY4dG$i__"